import slick from 'slick-carousel';
import imgLiquid from 'plugs/imgLiquid-min.js';
import 'plugs/jquery.mmenu.all.js';
import 'plugs/jquery.easing.1.3.js';
import 'plugs/svg.js';


var $window = $(window);
var $header = $('header nav');
var winW,winH,footerH,bodyH,scrollTop;
$(function() { 
    $('body').addClass('fade-in');    
    $("#topBtn").click(function() {
        $("html,body").animate({ scrollTop: 0 }, 1000, 'easeOutExpo');
        return false;
    });
    ///mobile menu
    var menuicon = $('header .menuicon'),
    navBox = $('header .mmenu'),
    nav = $('header .navBox'),
    $body = $('body'),
    $header = $('header');
    menuicon.on('click',function(){
        var $this = $(this);
        if(!$header.hasClass('menu-expanded')){
            $header.addClass('menu-expanded');
            nav.stop().fadeIn();
            $body.css({'overflow':'hidden'});
        }else{
            $header.removeClass('menu-expanded');
            nav.stop().fadeOut(function(){$(this).removeAttr('style');});
            $body.css({'overflow':''});
        }
        return false;
    });
    $window.on('resize',function(){
        winW = $window.width();
        winH =  $window.height();
        footerH = $('footer').outerHeight(true);
        bodyH = winH - footerH;  
        //bodyH
        $('main').css('min-height',bodyH);
        if(winW > 991){
            $header.removeClass('menu-expanded');
            $('.navBox').removeAttr('style');
            nav.stop().fadeOut(function(){$(this).removeAttr('style');});
            $body.css({'overflow':''});

            // $('.inner .temp2').slick('unslick');
        }
        resizeBgcover(winW);//background-image
    }).resize();    
    //scroll animation
    window.setTimeout(function(){
        $window.on('scroll', revealOnScroll);
        revealOnScroll();
    },1800);
    $window.on('scroll', function() {
        scrollTop = $(this).scrollTop();
        gotopfun(scrollTop);
    }).scroll();
    $('[data-down]').on('click',function(){
        var obj = $(this).data("down");
        var hidediv = $("#"+obj);
        if(hidediv.is(':hidden')){
            hidediv.slideDown();
            if(obj == "nav-search") $(this).next().addClass('is-open');
            if(obj == "prod-search") $(this).addClass('is-open');
        }else{
            hidediv.slideUp();
            if(obj == "nav-search") $(this).next().removeClass('is-open');
            if(obj == "prod-search") $(this).removeClass('is-open');
        }
    });
    $('[data-toggle]').on('click',function(){
        var obj = $(this).index();
        var hidediv = $('#hdtxt');
        if(!$(this).hasClass('active')){
            $('[data-toggle]').removeClass('active');
            $(this).addClass('active');
            hidediv.children('div').slideUp();
            hidediv.children('div').eq(obj).slideDown();
        }
        return false;
    });
    $('.slider-banner').on('init', function(event, slick){
        setTimeout(function(){
            $('.slider-banner').addClass('slickinit');
        },300);
        
    });
    if($('#scrtop').length > 0){        
        var offset = $("#scrtop").offset().top;
        $("html,body").animate({ scrollTop: offset });
        
    }
    if($('.indx').length > 0){ 
        var svg_circle = '<svg><circle cx="30" cy="30" r="28" /></svg>';
        $('.slider-banner').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: false,
            autoplay:true,
            autoplaySpeed:5000,
            speed:500,
            cssEase: 'linear',
            fade:true,
            arrows: false,
            dots: true,
            dotsClass: 'custom_paging',
            customPaging: function (slider, i) {
                var current = i + 1;
                var count = slider.slideCount;
                current = (current < 10) ? "0" + current : current;
                return current + svg_circle;
            },
        });
        $('.brands.archive').slick({
            slidesToScroll: 1,
            slidesToShow: 3,
            pauseOnHover:false,
            autoplay:false,
            speed:1500,
            arrows: false,
            dots: false,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,     
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2, 
                        variableWidth: false,
                        adaptiveHeight:true,
                        centerMode:true,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        variableWidth: false,
                        adaptiveHeight:true,
                        centerMode:true,
                    }
                }
            ]
        });        
        $('.btn-slick-prev').click(function(){
            $('.brands.archive').slick("slickPrev");
        });
        $('.btn-slick-next').click(function(){
            $('.brands.archive').slick("slickNext");
        });
    };
    
});
$('.clerbtn').on('click',function(){
    $("input").each(function() {
        $(this).prop("checked", false);
    });
});
$('.prod .sedbtn,.prod .srhbtn').on("click",function(e){
    search();
});
function search(){
    var div1= $("input[name='q1[]']:checked").map(function() { return $(this).val(); }).get();
    var div2= $("input[name='q2[]']:checked").map(function() { return $(this).val(); }).get();
    var div3= $(".prod input[name='kw']").val();
    var input1 = $("<input>").attr({"type":"hidden","name":"cid"}).val(div1);
    var input2 = $("<input>").attr({"type":"hidden","name":"pid"}).val(div2);
    var input3 = $("<input>").attr({"type":"hidden","name":"kw"}).val(div3);
    $('#ssf').append(input1);
    $('#ssf').append(input2);
    $('#ssf').append(input3);
    document.searchbx.submit();
}
$('.prodTarget').keypress(function(e){
    var code = (e.keyCode ? e.keyCode : e.which);
    if (code == 13) search();
});
$("input.headTarget").keypress(function(e){
	var code = (e.keyCode ? e.keyCode : e.which);
	if (code == 13){
		var kw = $(this).val();
		location.href = "products.php?cid=&pid=&kw="+kw;
	}
});
$("span.headTarget").on("click",function(e){
    var kw = $("#hdkw").val();
    if(kw){
		location.href = "products.php?cid=&pid=&kw="+kw;
    }
});
				